<mat-card
  cdkDrag
  cdkDropList
  [cdkDropListData]="item.children"
  dragAndDropManager
  (cdkDropListDropped)="onDragDrop$.next($event)"
  [ngClass]="{
    'background-invert': invert
  }"
  class="location">
  <mat-card-header fxLayoutAlign="start center">
    <div class="drag-handle">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" id="drag-indicator">
        <path fill="none" d="M0 0h24v24H0V0z"></path>
        <path
          d="M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path>
      </svg>
    </div>
    <div fxFlex>{{ item.name }}</div>
    <mat-icon *ngIf="level < 2" (click)="addSublocation(item)" class="location-add" [matTooltip]="'Add sublocation'">
      add
    </mat-icon>
    <mat-icon (click)="editLocation(item)" class="location-edit" [matTooltip]="'Edit location'">edit</mat-icon>
    <mat-icon (click)="removeLocation(item)" class="location-delete" [matTooltip]="'Delete location'">close</mat-icon>
  </mat-card-header>

  <mat-card-content *ngFor="let item of item.children">
    <sbnb-direct-location-editor-item
      [level]="level + 1"
      [item]="item"
      [invert]="!invert"
      [onDrop]="onDragDrop$"
      (itemAdded)="addSublocation($event)"
      (itemDeleted)="removeLocation($event)"
      (itemEdited)="editLocation($event)"></sbnb-direct-location-editor-item>
  </mat-card-content>
</mat-card>
